import { render, staticRenderFns } from "./BuilderCanvas.vue?vue&type=template&id=558b9a96&scoped=true"
import script from "./BuilderCanvas.vue?vue&type=script&lang=js"
export * from "./BuilderCanvas.vue?vue&type=script&lang=js"
import style0 from "./BuilderCanvas.vue?vue&type=style&index=0&id=558b9a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558b9a96",
  null
  
)

export default component.exports